import { observer } from "mobx-react";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import ContactSelectionModalStore from "../../store/ContactSelectionModalStore";
import SaveCancelFooter from "../footer/SaveCancelFooter";
import ContactPickList from "../pickList/ContactPickList";

const ContactSelectionModal: React.FC = () => {
  const [tempSelectedIds, setTempSelectedIds] = useState<string[]>([]);
  const { selectedIds, onSave, closeModal } = ContactSelectionModalStore;

  useEffect(() => {
    setTempSelectedIds(selectedIds || []);
  }, [selectedIds]);

  return (
    <Dialog
      visible={!!selectedIds}
      header="Kontakte verwalten"
      modal
      closable
      className="p-fluid"
      footer={
        <SaveCancelFooter
          submitAction={() => {
            onSave && onSave(tempSelectedIds);
            closeModal();
          }}
          cancelAction={closeModal}
        />
      }
      onHide={closeModal}
    >
      <ContactPickList
        selectedContactIds={tempSelectedIds}
        onChange={(newContactIds) => setTempSelectedIds(newContactIds)}
      />
    </Dialog>
  );
};

export default observer(ContactSelectionModal);
